import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Partners from './components/Partners';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';
import EngineeringPage from './components/EngineeringPage';
import IndustrialAutomationPage from './components/IndustrialAutomationPage';
import PrototypingPage from './components/PrototypingPage';
import RenderingAnimationPage from './components/RenderingAnimationPage';
import TrainingPage from './components/TrainingPage';
import ModelingPage from './components/ModelingPage';

// Home Page Component
const HomePage = () => (
  <>
    {/* Noise Overlay */}
    <div className="noise-overlay"></div>
    
    {/* Navigation */}
    <Navbar />
    
    {/* Main Content */}
    <main>
      <Hero />
      <About />
      <Services />
      <Partners />
      <Experience />
      <Contact />
    </main>
    
    {/* Footer */}
    <Footer />
  </>
);

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/engineering" element={<EngineeringPage />} />
            <Route path="/industrial-automation" element={<IndustrialAutomationPage />} />
            <Route path="/prototyping" element={<PrototypingPage />} />
            <Route path="/rendering-animation" element={<RenderingAnimationPage />} />
            <Route path="/training" element={<TrainingPage />} />
            <Route path="/3d-modeling" element={<ModelingPage />} />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
